import { Text, Accordion, JsonInput, ScrollArea, Code } from "@mantine/core";
import { EmailLog, ProcessStep } from "../../services/logService";
import { StructuredDataTable } from "./StructuredDataTable";

export function OcrResultStepContent({ log, logData }: { log: ProcessStep; logData: EmailLog }) {
  if (!logData.ocrResult) return null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const promptUsed = (log.details as any)?.promptUsed as string | undefined;
  return (
    <Accordion variant="contained" radius="sm" mt="xs">
      <Accordion.Item value="text">
        <Accordion.Control>
          <Text size="xs" fw={500}>
            抽出テキスト
          </Text>
        </Accordion.Control>
        <Accordion.Panel>
          <ScrollArea h={200}>
            <Code block style={{ whiteSpace: "pre-wrap", fontSize: "11px" }}>
              {logData.ocrResult.text || "(テキストなし)"}
            </Code>
          </ScrollArea>
        </Accordion.Panel>
      </Accordion.Item>
      {logData.ocrResult.structuredData && (
        <>
          <Accordion.Item value="table">
            <Accordion.Control>
              <Text size="xs" fw={500}>
                解析結果プレビュー（表形式）
              </Text>
            </Accordion.Control>
            <Accordion.Panel>
              <ScrollArea h={300}>
                <StructuredDataTable
                  data={logData.ocrResult.structuredData as Record<string, unknown>}
                />
              </ScrollArea>
            </Accordion.Panel>
          </Accordion.Item>
          <Accordion.Item value="structured">
            <Accordion.Control>
              <Text size="xs" fw={500}>
                構造化データ（JSON）
              </Text>
            </Accordion.Control>
            <Accordion.Panel>
              <JsonInput
                value={JSON.stringify(logData.ocrResult.structuredData, null, 2)}
                readOnly
                autosize
                minRows={4}
                maxRows={15}
                styles={{ input: { fontSize: "11px" } }}
              />
            </Accordion.Panel>
          </Accordion.Item>
        </>
      )}
      {logData.ocrResult.totalTokens && (
        <Accordion.Item value="usage">
          <Accordion.Control>
            <Text size="xs" fw={500}>
              トークン使用量
            </Text>
          </Accordion.Control>
          <Accordion.Panel>
            <Text size="xs">{logData.ocrResult.totalTokens.toLocaleString()} tokens</Text>
          </Accordion.Panel>
        </Accordion.Item>
      )}
      {promptUsed && (
        <Accordion.Item value="prompt">
          <Accordion.Control>
            <Text size="xs" fw={500}>
              使用されたプロンプト
            </Text>
          </Accordion.Control>
          <Accordion.Panel>
            <ScrollArea h={300}>
              <Code block style={{ whiteSpace: "pre-wrap", fontSize: "11px" }}>
                {promptUsed}
              </Code>
            </ScrollArea>
          </Accordion.Panel>
        </Accordion.Item>
      )}
    </Accordion>
  );
}
